import React from "react";
import { Link } from "react-router-dom";

import {
	BriefcaseIcon,
	BuildingIcon,
	GlobeIcon,
	MapPinIcon,
	UsersIcon,
} from "@/app/assets/icons/interface/interface.jsx";

import { Card, CardContent, CardHeader, CardTitle } from "../../../../../JobsPage/components/Card";
import { JobDetails } from "../utils/helpers";

interface CompanyCardProps {
	jobDetails: JobDetails;
}

export function CompanyCard({ jobDetails }: CompanyCardProps) {
	return (
		<Card className="shadow-md overflow-hidden">
			<CardHeader className="bg-gray-50 border-b border-gray-200">
				<CardTitle className="text-base font-semibold font-plus-jakarta">
					About {jobDetails?.company?.company_name || ""}
				</CardTitle>
			</CardHeader>
			<CardContent className="p-6">
				<div className="flex items-center mb-4">
					<div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 border border-gray-100 mr-4">
						<Link to={`/companies/${jobDetails?.company?._id}`} state={jobDetails?.company}>
							<img
								alt={`${jobDetails?.company?.company_name || ""} logo`}
								loading="lazy"
								width="64"
								height="64"
								decoding="async"
								data-nimg="1"
								className="w-full h-full object-cover"
								style={{ color: "transparent" }}
								src={jobDetails?.company ? jobDetails?.company?.logo_url : "https://via.placeholder.com/150"}
								onError={(e) => ((e.target as HTMLImageElement).src = "/images/co-placeholder.png")}
							/>
						</Link>
					</div>
					<div>
						<p className="text-gray-700 mt-1 font-inter text-sm">{jobDetails?.company?.about_us_summary}</p>
					</div>
				</div>
				<div className="flex flex-wrap gap-2 text-sm text-gray-600 font-inter mb-4">
					<span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200/50 text-gray-800">
						<BuildingIcon className="w-3 h-3 mr-1 text-gray-600" />
						{jobDetails?.company?.company_industry}
					</span>
					<span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200/50 text-gray-800">
						<UsersIcon className="w-3 h-3 mr-1 text-gray-600" />
						{jobDetails?.company?.company_size_approx} Employees
					</span>
					<span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200/50 text-gray-800">
						<MapPinIcon className="w-3 h-3 mr-1 text-gray-600" />
						{jobDetails?.jobLocation?.city}, {jobDetails?.jobLocation?.region}
					</span>
					<span
						className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-green-800"
						style={{ color: "#34663D", backgroundColor: "#E2FBE8" }}
					>
						<BriefcaseIcon className="w-3 h-3 mr-1 text-green-600" />
						Actively Hiring
					</span>
				</div>
				<div className="flex items-center">
					<GlobeIcon className="w-5 h-5 mr-2 text-gray-600" />
					<span className="font-semibold mr-1 text-sm">Website:</span>
					<a
						href={jobDetails?.company?.company_website}
						target="_blank"
						rel="noopener noreferrer"
						className="text-primary-700 hover:underline text-sm"
					>
						{jobDetails?.company?.company_website}
					</a>
				</div>
			</CardContent>
		</Card>
	);
}
